import { Dropdown, Input, Radio, SelectDatePicker } from 'ui';

import { IPropsRadio } from '../../../../ui/Radio';

import { IFormGen } from './FormGen';

const schemaForm: IFormGen.ISchema = {
  TEXT: {
    component: (props) => <Input {...props} />,
  },
  NUMBER: {
    component: (props) => (
      <Input isNumber type="number" pattern="[0–9]*" inputmode="decimal" {...props} />
    ),
  },
  RADIO: {
    component: (props: IPropsRadio) => <Radio {...props} />,
  },
  DATE: {
    component: (props) => <SelectDatePicker {...props} />,
  },
  DROPDOWN: {
    component: (props) => <Dropdown {...props} marginWrapper="8px 0 16px 0" />,
  },
  MAP: {
    component: (props) => <Dropdown {...props} />,
  },
};

export default schemaForm;
